import React, { useEffect, useState, useCallback } from "react";
import Spinner from "../../components/Spinner";
import UserSchema from "./UserSchema";
import { translate } from "../../components/Language/Translate";
import FormValidation from "../Validation/FormValidation";
import { simpleRequest } from "../simpleRequest";
import UserLoginFields from "./UserLoginFields";
import FieldValidation from "../Validation/FieldValidation";
import { LargeButton } from "../../components/styledComponents/colors";
import Spinning from "../../components/Spinning";
import FormatText from "../../helpers/FormatText";
import { inside } from "../../config";
import AdminArea from "../../components/Admin/AdminArea";
// import AdminArea from "components/Admin/AdminArea";

const UserLogin = () => {
  const [view, setView] = useState("input"); // input, waiting, success, null
  const [isLoading, setIsLoading] = useState(true);
  const [fieldSettings, setFieldSettings] = useState({});
  const [variables, setVariables] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [serverError, setServerError] = useState("");

  // console.log("inside UserLogin", { fieldSettings });

  const validateField = e => {
    const val = new FieldValidation(e.target.name, e.target.value, fieldSettings, variables);
    const errMsg = val.isValid().errMsg;
    (() => setFieldErrors({ ...fieldErrors, [e.target.name]: errMsg }))();
  };

  const fetch = useCallback(async () => {
    const schema = new UserSchema();
    const vars = {};
    const fields = {};
    const fieldArr = ["email", "password"];
    fieldArr.forEach(i => {
      fields[i] = schema.fields[i];
      vars[i] = "";
    });
    (() => setFieldSettings(fields))();
    (() => setVariables(vars))();
    (() => setIsLoading(false))();
  }, []);
  useEffect(() => {
    if (isLoading) fetch();
  }, [isLoading, fetch]);

  if (isLoading) return <Spinner />;

  const handleChange = e => setVariables({ ...variables, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    console.log("####################################################################");
    const formValidation = new FormValidation({ fieldSettings, variables });
    console.log({ formValidation });
    if (!formValidation.valid) return;
    inside();

    (() => setView("waiting"))();
    const request = { url: "users/login", method: "post", data: { ...variables } };
    console.log({ request });
    const response = await simpleRequest(request);
    const user = response.data?.user;
    console.log("user: ", user);
    if (user) {
      console.log({ user });
      localStorage.setItem("user", JSON.stringify(user));
      (() => setView("success"))();
      setTimeout(() => (window.location.href = "/"), 2000);
    } else {
      console.log(response, response.errorMessage);
      setServerError(response.errorMessage);
      setView(null);
      setTimeout(() => {
        setServerError("");
        setView("input");
      }, 3000);
    }
  };

  const props = {
    fieldSettings,
    setFieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
    handleChange,
    validateField
  };

  const ServerError = () => (
    <div className="my-3 p-2 text-danger text-center">
      <FormatText str={serverError} />
    </div>
  );

  const SuccessArea = () => (
    <div>
      <h5>{translate("Login war erfolgreich.")}</h5>
    </div>
  );
  // console.log({ variables });
  return (
    <div style={{ backgroundColor: "rgba(255,255,255,.5)", borderRadius: "5px" }} className="p-3 text-center">
      {serverError && <ServerError />}
      {view === "success" && <SuccessArea />}
      {view === "waiting" && <Spinning />}
      {view === "input" && <h4>{translate("Login")}</h4>}
      {view === "input" && <UserLoginFields props={props} />}
      {view === "input" && (
        <LargeButton type="submit" onClick={handleSubmit}>
          {translate("Login")}
        </LargeButton>
      )}
      <AdminArea />
    </div>
  );
};
export default UserLogin;
